import script from "./CommissionRuleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionRuleForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__